"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DarkPalette = exports.LightPalette = void 0;
exports.LightPalette = {
    Primary: '#5c688e', // Nextep Purple
    Secondary: '#3fad98', // Nextep Green
    Tertiary: '#d7df23', // Nextep Gross Yellow Green
    //Primary Background
    PrimaryBackground: '#E7EBF8',
    PrimaryBackgroundLight: '#F0F3FF',
    PrimaryBackgroundAlmostGray: '#F6F7FF',
    //Primary Background Hover
    PrimaryBackgroundLightHover: '#E7EBFA',
    //Primary Background Selected
    PrimaryBackgroundSelected: '#D4DAEC',
    PrimaryBackgroundLightSelected: '#E0E5F7',
    PrimaryBackgroundAlmostGraySelected: '#E2E6F5',
    // Primary Background - Secondary Selected
    PrimaryBackgroundSecondarySelected: '#B2DFDA',
    PrimaryBackgroundSecondaryLightSelected: '#C0E6E1',
    PrimaryBackgroundSecondaryAlmostGraySelected: '#CBEBE7',
    PrimaryLight: '#D1D8ED',
    PrimaryLightest: '#F0F1F8',
    PrimaryDark: '#5c688e',
    SecondaryLight: '#c5eae3',
    SecondaryLightest: '#edf8f6',
    TertiaryLight: '#f3f6bf',
    TertiaryLightest: '#fbfceb',
    OpaqueSecondary: '#68C6B955',
    AlwaysWhite: '#FFFFFF',
    White: '#FFFFFF',
    Coral: '#ff7675',
    OpaqueCoral: '#ff767555',
    Red: '#C0392B',
    OpaqueRed: '#C0392B55',
    RedLightest: '#C0392B11',
    ErrorTagText: '#A44F4C',
    ErrorTagBackground: '#FFC2B5',
    ToastError: '#A44F4C',
    ToastErrorText: '#FFC2B5',
    ToastWarning: '#f77c00',
    ToastWarningLightest: '#fff1e4',
    ToastInfo: '#658BDB',
    AlmostClear: '#ffffff11',
    RedNotification: '#f5d5d2',
    Blue: '#2980B9',
    Green: '#27AE60',
    Black: '#000000',
    Amber: '#F39C12',
    Tangerine: '#ff9f43',
    Magenta: '#f368e0',
    Slate: '#636e72',
    Teal: '#00cec9',
    Butter: '#ffeaa7',
    SkyBlue: '#74b9ff',
    CoolGray: '#7f8c8d',
    Salmon: '#F68280',
    Gray: '#BDC3C7',
    LightGray: '#DEDEDE',
    UltraLightGray: '#F3F3F3',
    OffWhiteGray: '#F8F9FA',
    SoftGray: '#F9F9F9',
    LavenderGray: '#D1D7ED',
    NeutralGray: '#d4d4d4',
    OffWhite: '#F9FAFB',
    ImageNull: '#E4E4E4',
    Warning: '#f1c40f',
    WarningLightest: '#fef9e7',
    WarningText: '#333333',
    Text: '#333333',
    TextLight: '#999999',
    TextMuted: '#444444',
    TextDisabled: '#A3AAB4',
    TextNull: '#BDBDBD',
    TextSecondary: '#888888',
    CardBackground: "#FFFFFF",
    CardBorder: '#D8D8D8',
    ScreenBackground: '#f0f0f0',
    ButtonBackground: 'transparent',
    ButtonDisabled: 'transparent',
    SolidButtonDisabled: '#E7EAEE',
    ButtonBorderDisabled: '#bbc3cc',
    SmokeWhite: '#F4F4F4',
    SmokeWhiteText: '#555555',
    TabBackground: '#3fad9811',
    TabBorder: '#E2E2E2',
    FocusedTabText: '#222',
    UnfocusedTabText: '#555',
    Background: '#FFFFFF',
    Surface: '#FFFFFFFF',
    SurfaceVariant: '#E1E3F9',
    OnSurface: '#333333FF',
    OnSurfaceVariant: '#5c688eee',
    Outline: '#5c688e',
    SurfaceDisabled: '#a5aab4',
    OnSurfaceDisabled: '#a5aab4',
    PrimaryContainer: '#E1E3F9',
    SecondaryContainer: '#D1ECE8',
    ImagesBackground: 'transparent'
};
exports.DarkPalette = {
    Primary: '#A1ADD8',
    Secondary: '#68C6B9',
    Tertiary: '#D7DF23',
    //Primary Background
    PrimaryBackground: '#202126',
    PrimaryBackgroundLight: '#292A30',
    PrimaryBackgroundAlmostGray: '#18191F',
    //Primary Background Hover
    PrimaryBackgroundLightHover: '#33353C',
    //Primary Background Selected
    PrimaryBackgroundSelected: '#323640',
    PrimaryBackgroundLightSelected: '#3B3F49',
    PrimaryBackgroundAlmostGraySelected: '#292C35',
    // Primary Background - Secondary Selected
    PrimaryBackgroundSecondarySelected: '#48A396',
    PrimaryBackgroundSecondaryLightSelected: '#53B2A5',
    PrimaryBackgroundSecondaryAlmostGraySelected: '#3E988B',
    PrimaryLight: '#494F68',
    PrimaryLightest: '#3b3e52',
    PrimaryDark: '#535e7a',
    SecondaryLight: '#2A7067',
    SecondaryLightest: '#274C4A',
    TertiaryLight: '#73772F',
    TertiaryLightest: '#4A4D1F',
    OpaqueSecondary: '#68C6B955',
    AlwaysWhite: '#FFFFFF',
    White: '#1E1E1E',
    Coral: '#ff8b89',
    OpaqueCoral: '#ff767555',
    Red: '#C94A44',
    OpaqueRed: '#C0392B55',
    RedLightest: '#783836',
    ErrorTagText: '#ff9a8a',
    ErrorTagBackground: '#783836',
    ToastError: '#783836',
    ToastErrorText: '#ff9a8a',
    ToastWarning: '#F0A158',
    ToastWarningLightest: '#DDC19E',
    ToastInfo: '#76A3EC',
    AlmostClear: '#ffffff11',
    RedNotification: '#8d413e',
    Blue: '#51A7E1',
    Green: '#3FCF7E',
    Black: '#FFFFFF',
    Amber: '#FFB74D',
    Tangerine: '#f9b472',
    Magenta: '#ed78dd',
    Slate: '#97a0a4',
    Teal: '#2bcac6',
    Butter: '#ecd079',
    SkyBlue: '#76b7f9',
    CoolGray: '#afb6b6',
    Salmon: '#F68280',
    Gray: '#6E6E6E',
    LightGray: '#4D4C4C',
    UltraLightGray: '#454A5A',
    OffWhiteGray: '#3D4150',
    SoftGray: '#292A2D',
    LavenderGray: '#2E3550',
    NeutralGray: '#737c8d',
    OffWhite: '#3A3F4B',
    ImageNull: '#6B7280',
    Warning: '#f7c041',
    WarningLightest: '#9B8240',
    WarningText: '#333333',
    Text: '#FFFFFF',
    TextMuted: '#E1E1E6',
    TextLight: '#9B9B9B',
    TextDisabled: '#ffffff71',
    TextNull: '#9CA3AF',
    TextSecondary: '#A1ADD8B3',
    CardBackground: "#2F323B",
    CardBorder: '#42485E',
    ScreenBackground: '#222222',
    ButtonBackground: '#20232eff',
    ButtonDisabled: 'transparent',
    SolidButtonDisabled: '#FFFFFF14',
    ButtonBorderDisabled: '#FFFFFF1F',
    SmokeWhite: '#4A5063',
    SmokeWhiteText: '#D6DBE6',
    TabBackground: '#818f8c7c',
    TabBorder: '#373b4bff',
    FocusedTabText: '#FFFFFF',
    UnfocusedTabText: '#dbdbdb',
    Background: '#2F323B',
    Surface: '#3E4354',
    SurfaceVariant: '#48556B',
    OnSurface: '#E6EAF2',
    OnSurfaceVariant: '#929DC2',
    Outline: '#929DC2',
    SurfaceDisabled: '#FFFFFF66',
    OnSurfaceDisabled: '#FFFFFF66',
    PrimaryContainer: '#243044',
    SecondaryContainer: '#85b8af',
    ImagesBackground: '#D2D8ED'
};
